export function instanceOfError(err: unknown): err is Error {
  return err instanceof Error && Boolean(err.message)
}
